import React, { useState, useEffect, useRef, use } from "react";
import PropTypes from "prop-types";
import { db, auth } from "../firebase";
import Logo from "../assets/bluesky-logo-navbar.svg";
import {
  collection,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  onSnapshot,
  query,
  orderBy,
} from "firebase/firestore";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import Menu from "../pages/Profile-Popup/Menu";
import { useAuth } from "./AuthContext";
import ContactSupport from "../pages/Profile-Popup/ContactSupport";
import Popup from "./Popup";
import { useSearchParams, useNavigate } from "react-router-dom";
import EmergencyBanner from "./Notifications/EmergencyBanner";
import EmergencyPopup from "./Notifications/EmergencyPopup";
import NotificationPanel from "./Notifications/NotificationPanel";
import { useNotifications } from "./Notifications/useNotifications";
import NotificationButton from "./Notifications/NotificationButton";

const Navbar = () => {
  const [userId, setUserId] = useState(null);
  const [data, setData] = useState([]);
  const { role } = useAuth();
  const [searchParams] = useSearchParams();
  const isDupAddress = searchParams.get("dupAddress") === "true";
  const [showPopup, setShowPopup] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const {
    notifications,
    unreadNotifications,
    emergencyNotification,
    showEmergencyPopup,
    markEmergencyAsRead,
    markNotificationAsRead
  } = useNotifications();
  const navigate = useNavigate();
  const selectedUserId = sessionStorage.getItem("userId");

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser && selectedUserId) {
        setUserId(selectedUserId);
      } else {
        setData(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (userId) {
      fetchData();
      console.log("Rolee: " + role);
    }
  }, [userId]);

  const fetchData = async () => {
    try {
      const userDocRef = doc(db, "users", selectedUserId);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        const userData = userDocSnap.data();
        // if duplicate address, show the popup message
        if (isDupAddress) setShowPopup(true);

        if (userData.user_role === "center") {
          console.log("Center ID: " + userData.center_id);
          const centerDocRef = doc(db, "centers", userData.center_id);
          const centerDocSnap = await getDoc(centerDocRef);
          if (centerDocSnap.exists()) {
            setData({ id: centerDocSnap.id, ...centerDocSnap.data() });
          }
        } else if (userData.user_role === "partner") {
          const partnerDocRef = doc(db, "partners", userData.partner_id);
          const partnerDocSnap = await getDoc(partnerDocRef);
          if (partnerDocSnap.exists()) {
            setData({ id: partnerDocSnap.id, ...partnerDocSnap.data() });
          }
        } else {
          setData({ id: userDocSnap.id, ...userDocSnap.data() });
        }
      } else {
        console.error("No such document!");
      }
    } catch (error) {
      console.error("Error fetching user data: ", error);
    }
  };

  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const [showSupport, setShowSupport] = useState(false);

  const toggleSupport = () => {
    setShowSupport(!showSupport);
  };

  return (
    <nav
      className={`bg-header-panel h-[6vh] border-none text-white shadow-none`}
    >
      <div
        className={`bg-header-panel fixed left-0 right-0 top-0 z-10 flex h-[6vh] w-full flex-row items-center justify-between text-left font-poppins text-base leading-[normal] tracking-[normal] text-white shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)]`}
      >
        {/* Blue Sky Logo */}
        <div className="flex h-[6vh] flex-row items-center justify-center gap-[11px] pl-7">
          <img src={Logo} alt="Blue Sky Logo" width="41" height="45" />
          <div className="flex flex-col items-start font-semibold text-[inherit]">
            <div className="flex flex-col items-baseline text-white">
              <p className="header-logo-label">DARCI</p>
              <p className="header-powered-by -my-1 text-[8px] font-normal">
                Disaster Aware & Ready Communities
              </p>
            </div>
          </div>
        </div>

        {/* <EmergencyBanner notification={emergencyNotification} /> */}
        <NotificationPanel
          isOpen={showNotifications}
          onClose={() => setShowNotifications(false)}
          notifications={notifications}
          markNotificationAsRead={markNotificationAsRead}
        />
        {/* {showEmergencyPopup && emergencyNotification && (
                <EmergencyPopup
                    notification={emergencyNotification}
                    onClose={markEmergencyAsRead}
                />
            )} */}
        {/* User Nav */}
        <div className="flex max-h-[6vh] flex-col items-center justify-center pr-7 text-right text-xs text-honeydew">
          <div className="flex flex-row items-center justify-center gap-[14px]">
            {role === "citizen" && (
              <div
                onClick={() => navigate("/opportunities/donate")}
                className="flex cursor-pointer items-center justify-center"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="24" height="24" rx="6" fill="#F9B54C" />
                  <path
                    d="M13.4286 19.3688C13.5683 19.4063 13.7302 19.4219 13.9143 19.4156C14.0984 19.4094 14.254 19.3812 14.381 19.3312L20 17.25C20 16.825 19.8476 16.4687 19.5429 16.1812C19.2381 15.8937 18.8825 15.75 18.4762 15.75H13.2571C13.219 15.75 13.1746 15.7469 13.1238 15.7406C13.073 15.7344 13.0349 15.725 13.0095 15.7125L11.8857 15.3188C11.7841 15.2813 11.7143 15.2188 11.6762 15.1313C11.6381 15.0438 11.6317 14.95 11.6571 14.85C11.6825 14.7625 11.746 14.6938 11.8476 14.6438C11.9492 14.5938 12.0508 14.5875 12.1524 14.625L13.0095 14.9438C13.0603 14.9688 13.1016 14.9844 13.1333 14.9906C13.1651 14.9969 13.2127 15 13.2762 15H15.2762C15.5175 15 15.7302 14.9188 15.9143 14.7563C16.0984 14.5938 16.1905 14.3812 16.1905 14.1187C16.1905 13.9437 16.1365 13.775 16.0286 13.6125C15.9206 13.45 15.7778 13.3375 15.6 13.275L10.3238 11.3438C10.2349 11.3187 10.146 11.2969 10.0571 11.2781C9.96825 11.2594 9.87937 11.25 9.79048 11.25H8.57143V18.0187L13.4286 19.3688ZM4 18C4 18.4125 4.14921 18.7656 4.44762 19.0594C4.74603 19.3531 5.10476 19.5 5.52381 19.5C5.94286 19.5 6.30159 19.3531 6.6 19.0594C6.89841 18.7656 7.04762 18.4125 7.04762 18V12.75C7.04762 12.3375 6.89841 11.9844 6.6 11.6906C6.30159 11.3969 5.94286 11.25 5.52381 11.25C5.10476 11.25 4.74603 11.3969 4.44762 11.6906C4.14921 11.9844 4 12.3375 4 12.75V18ZM15.4286 12.15C15.2381 12.15 15.0508 12.1156 14.8667 12.0469C14.6825 11.9781 14.5143 11.875 14.3619 11.7375L12.2667 9.7125C11.873 9.3375 11.5397 8.92187 11.2667 8.46562C10.9937 8.00937 10.8571 7.5125 10.8571 6.975C10.8571 6.2875 11.1016 5.70313 11.5905 5.22188C12.0794 4.74063 12.673 4.5 13.3714 4.5C13.7778 4.5 14.1587 4.58437 14.5143 4.75313C14.8698 4.92188 15.1746 5.15 15.4286 5.4375C15.6825 5.15 15.9873 4.92188 16.3429 4.75313C16.6984 4.58437 17.0794 4.5 17.4857 4.5C18.1841 4.5 18.7778 4.74063 19.2667 5.22188C19.7556 5.70313 20 6.2875 20 6.975C20 7.5125 19.8667 8.00937 19.6 8.46562C19.3333 8.92187 19.0032 9.3375 18.6095 9.7125L16.4952 11.7375C16.3429 11.875 16.1746 11.9781 15.9905 12.0469C15.8063 12.1156 15.619 12.15 15.4286 12.15Z"
                    fill="#A2211A"
                  />
                </svg>
              </div>
            )}

            <svg
              width="26"
              height="27"
              viewBox="0 0 26 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={toggleSupport}
            >
              <path
                d="M19.6104 1H6.61035C3.29664 1 0.610352 3.68629 0.610352 7V20C0.610352 23.3137 3.29664 26 6.61035 26H19.6104C22.9241 26 25.6104 23.3137 25.6104 20V7C25.6104 3.68629 22.9241 1 19.6104 1Z"
                fill="#FBBB4C"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.86035 11.0208C7.86035 9.55658 8.41347 8.15235 9.39804 7.117C10.3826 6.08165 11.718 5.5 13.1104 5.5C14.5028 5.5 15.8381 6.08165 16.8227 7.117C17.8073 8.15235 18.3604 9.55658 18.3604 11.0208V11.8371C19.6324 12.0287 20.6104 13.1794 20.6104 14.5698V14.767C20.6103 15.109 20.5451 15.4475 20.4187 15.7626C20.2923 16.0777 20.1072 16.363 19.8743 16.6017C19.6415 16.8404 19.3655 17.0277 19.0627 17.1526C18.76 17.2774 18.4365 17.3373 18.1114 17.3287C17.5564 19.0007 16.1449 20.1277 14.6217 20.4132C14.2692 20.5489 13.8521 20.485 13.4854 20.485C13.187 20.485 12.9009 20.3603 12.6899 20.1385C12.4789 19.9166 12.3604 19.6157 12.3604 19.3019C12.3604 18.9882 12.4789 18.6873 12.6899 18.4654C12.9009 18.2436 13.187 18.1189 13.4854 18.1189H14.2354C14.4115 18.1189 14.5852 18.1623 14.7424 18.2457C14.8996 18.3292 15.036 18.4502 15.1406 18.5992C16.1126 18.1126 16.8604 17.085 16.8604 15.7529V11.0208C16.8604 9.97492 16.4653 8.9719 15.7621 8.23236C15.0588 7.49283 14.105 7.07737 13.1104 7.07737C12.1158 7.07737 11.162 7.49283 10.4587 8.23236C9.75544 8.9719 9.36035 9.97492 9.36035 11.0208V15.95C9.36035 16.3161 9.22207 16.6672 8.97593 16.926C8.72979 17.1848 8.39595 17.3302 8.04785 17.3302C7.40138 17.3302 6.7814 17.0602 6.32428 16.5795C5.86716 16.0988 5.61035 15.4468 5.61035 14.767V14.5698C5.61019 13.9059 5.83757 13.2642 6.25082 12.7623C6.66406 12.2604 7.23549 11.9319 7.86035 11.8371V11.0208ZM7.86035 13.4539C7.64092 13.5354 7.45095 13.6866 7.31662 13.8865C7.1823 14.0863 7.11023 14.3251 7.11035 14.5698V14.767C7.11035 15.2442 7.43285 15.6425 7.86035 15.7332V13.4539ZM18.3604 13.4539V15.7332C18.7879 15.6417 19.1104 15.2442 19.1104 14.767V14.5698C19.1105 14.3251 19.0385 14.0863 18.9041 13.8865C18.7698 13.6866 18.5798 13.5354 18.3604 13.4539Z"
                fill="#9C1717"
              />
            </svg>

            <NotificationButton
              unreadNotifications={unreadNotifications}
              onClick={() => setShowNotifications(true)}
            />

            <div className="flex flex-col items-end justify-start">
              <p
                className="relative inline-block min-w-[86px] cursor-pointer font-semibold text-[inherit] [text-decoration:none]"
                onClick={toggleMenu}
              >
                {selectedUserId &&
                  (data.first_name
                    ? data.first_name
                    : // eslint-disable-next-line no-useless-concat
                    "First Name" + " " + data.last_name
                    ? data.last_name
                    : "Last Name")}
              </p>
              {/* <p className="relative inline-block min-w-[40px] font-light text-white [text-decoration:none]">
                {role === "admin"
                  ? "Admin"
                  : role === "citizen"
                  ? "Citizen"
                  : role === "center"
                  ? "Center"
                  : "Partner"}
              </p> */}
            </div>
            <div
              className="box-border flex h-[25px] w-[25px] cursor-pointer flex-col items-start justify-start px-0 pb-0  text-center"
              onClick={toggleMenu}
            >
              <div className="bg-gold flex h-[25px]  w-[25px] flex-row items-center justify-center self-stretch rounded-md">
                <div className="relative hidden h-[25px] w-[25px] rounded-md bg-white " />
                <p className="relative z-[1] font-medium text-[inherit] [text-decoration:none]">
                  {selectedUserId &&
                    (data.first_name
                      ? data.first_name.charAt(0)
                      : role === "partner"
                      ? "P"
                      : role === "center"
                      ? "C"
                      : role === "admin"
                      ? "A"
                      : "")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Menu isOpen={showMenu} onClose={toggleMenu} data={data} />
      <ContactSupport
        isOpen={showSupport}
        onClose={toggleSupport}
        data={data}
      />
      {showPopup && (
        <Popup
          title="Duplicate Address Notification"
          message="The duplicate address registration has been recorded. Thank you for reporting this activity."
          onClose={() => setShowPopup(false)}
        />
      )}
    </nav>
  );
};

export default Navbar;
